export const brand = {
  name: "爆点投稿社",
  shortName: "爆点社",
  slogan: "让每一条线索，都有机会引爆全网",
  intro:
    "爆点投稿社是一个面向普通人的爆料投稿与选题参考平台。我们把近期正在征集的高热度话题、爆款稿件的共同特征、容易过稿的标题写法与编辑的真实偏好，整理成看得懂、用得上的参考，让没有投稿经验的人也能写出被选中的稿件。",
  email: "tougao@baodianshe.com",
  replyPolicy: "工作日 24 小时内给出初审答复",
  founded: "2021",
};

export const navLinks = [
  { label: "首页", to: "/" },
  { label: "选题库", to: "/topics" },
  { label: "投稿指南", to: "/guide" },
  { label: "关于我们", to: "/about" },
  { label: "我要投稿", to: "/submit" },
];

export const stats = [
  { value: "3,600+", label: "累计收录投稿线索" },
  { value: "480+", label: "已跟进报道选题" },
  { value: "46%", label: "新手首投过稿率" },
  { value: "24h", label: "工作日初审反馈" },
];

export const values = [
  {
    icon: "ri-radar-line",
    title: "选题实时更新",
    desc: "编辑每天整理正在征集的方向，标注热度与截止时间，避免你把稿子投给已经凉透的话题。",
    tag: "选题弹药库",
  },
  {
    icon: "ri-file-text-line",
    title: "稿件标准透明",
    desc: "把编辑内部判断稿件好坏的维度公开出来，从线索真实度到叙述结构，逐条对照自查。",
    tag: "过稿说明书",
  },
  {
    icon: "ri-price-tag-3-line",
    title: "标题实验室",
    desc: "同一件事的平庸标题与爆款标题并排对比，讲清楚差别在哪里、为什么点击率会翻倍。",
    tag: "点击率拆解",
  },
  {
    icon: "ri-shield-user-line",
    title: "线人保护优先",
    desc: "投稿信息全程加密，支持匿名与化名，涉及敏感内容时编辑会先与你对齐保护方案。",
    tag: "安全投稿",
  },
];

export const workflow = [
  {
    step: "01",
    icon: "ri-lightbulb-flash-line",
    title: "从选题库挑方向",
    desc: "在选题库按分类浏览正在征集的话题，挑一个你手上有材料、有渠道的方向作为切入点。",
  },
  {
    step: "02",
    icon: "ri-draft-line",
    title: "按清单写初稿",
    desc: "对照投稿指南里的清单，把时间、地点、人物、关键证据与你的独家观察补齐。",
  },
  {
    step: "03",
    icon: "ri-send-plane-line",
    title: "在线提交线索",
    desc: "通过投稿表单提交文字与材料链接，填写是否能补充采访，方便编辑判断跟进方式。",
  },
  {
    step: "04",
    icon: "ri-chat-check-line",
    title: "与编辑对齐跟进",
    desc: "编辑在 24 小时内给出初审意见，合适选题会与你确认细节、授权范围与署名方式。",
  },
];

export const principles = [
  {
    icon: "ri-checkbox-circle-line",
    title: "真实优先",
    desc: "不追求耸动，只追求可核实。无法确认来源的信息，会先标注存疑，再决定是否跟进。",
  },
  {
    icon: "ri-scales-3-line",
    title: "多方求证",
    desc: "任何涉事主体都有一方回应机会，报道前会尽量补齐当事人、管理方与知情人的说法。",
  },
  {
    icon: "ri-eye-off-line",
    title: "最小伤害",
    desc: "涉及未成年人、受害者与举报人时，主动模糊可识别信息，避免二次伤害。",
  },
  {
    icon: "ri-refresh-line",
    title: "持续更正",
    desc: "稿件出现偏差时公开更正，不悄悄删改，让读者能看到信息变化的过程。",
  },
];